import React from 'react';
import Hero from '../../components/Hero/Hero';
import QuickBooking from '../../components/QuickBooking/QuickBooking';
import Specialties from '../../components/Specialties/Specialties';
import SmartSearch from '../../components/SmartSearch/SmartSearch';
import TrustSection from '../../components/TrustSection/TrustSection';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="home-page">
      <Hero />
      <QuickBooking />
      <Specialties />
      <SmartSearch />
      <TrustSection />
    </div>
  );
};

export default HomePage;
